<!-- 溯源码套餐 -->
<template>
    <div>
        <div class="header">
            <Input
                class="w200 mr24 mb24"
                type="text"
                v-model="storePrams.keywords"
                placeholder="请输入溯源码套餐名称"
            ></Input>
            <Select
                class="w200 mr24 mb24"
                v-model="storePrams.status"
                clearable
                filterable
            >
                <Option
                    v-for="item in statusList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.name }}</Option
                >
            </Select>
            <Button
                class="theme-bc mb24"
                icon="ios-search"
                type="warning"
                @click="goSearch"
                >确认搜索</Button
            >
        </div>
        <div class="content">
            <Button
                class="theme-bc mb24"
                icon="md-add-circle"
                type="warning"
                @click="gomodal"
                >增加码套餐</Button
            >
            <Table :columns="columnsTable" :data="dataTable" border>
                <template slot-scope="{ row }" slot="status">
                    <div class="flex-c">
                        <i-switch
                            v-model="row.status"
                            size="large"
                            true-color="#FF761D "
                            :true-value="1"
                            :false-value="0"
                            @on-change="changeStatus(row)"
                        >
                            <span slot="open">开启</span>
                            <span slot="close">关闭</span>
                        </i-switch>
                    </div>
                </template>
                <template slot-scope="{ row }" slot="operate">
                    <div class="flex-sa">
                        <Button
                            type="primary"
                            ghost
                            label="small"
                            @click="gomodal(row)"
                            >编辑</Button
                        >
                        <Button
                            type="error"
                            ghost
                            label="small"
                            @click="goDel(row)"
                            >删除</Button
                        >
                    </div>
                </template>
            </Table>
            <div class="text-align-right mt24">
                <Page
                    :current="storePrams.page"
                    :page-size="storePrams.limit"
                    :total="total"
                    show-total
                    @on-change="pageChange"
                />
            </div>
        </div>

        <!-- 新增/编辑 -->
        <Modal
            v-model="modals"
            :title="modalTitle"
            width="600"
            :mask-closable="false"
        >
            <div>
                <Form
                    :model="form_item"
                    label-position="right"
                    :label-width="130"
                >
                    <FormItem label="序号：">
                        <Input
                            class="w300"
                            type="number"
                            v-model="form_item.sort"
                            placeholder="请输入"
                        ></Input>
                        <Tooltip
                            max-width="250"
                            placement="right"
                            theme="light"
                        >
                            <Icon
                                class="tooltip-icon"
                                type="md-help-circle"
                                size="20"
                                color="#FF761D"
                            />
                            <div slot="content"><p>正序，序号越小，越在前面</p></div>
                        </Tooltip>
                    </FormItem>
                    <FormItem label="套餐名称：">
                        <Input
                            class="w300"
                            type="text"
                            v-model="form_item.name"
                            placeholder="请输入套餐名称"
                        ></Input>
                    </FormItem>
                    <FormItem label="码数量：">
                        <Input
                            class="w300"
                            type="number"
                            v-model="form_item.nums"
                            placeholder="请输入码数量"
                        ></Input>
                    </FormItem>
                    <FormItem label="原价：">
                        <Input
                            class="w300"
                            type="number"
                            v-model="form_item.ori_price"
                            placeholder="请输入原价"
                        ></Input>
                    </FormItem>
                    <FormItem label="售价:">
                        <Input
                            class="w300"
                            type="number"
                            v-model="form_item.price"
                            placeholder="请输入售价"
                        ></Input>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelModal">取消</Button>
                <Button class="theme-bc" type="warning" @click="submitModal"
                    >确认</Button
                >
            </div>
        </Modal>
    </div>
</template>

<script>
import { version_qrcode, version_qrcode_save, version_qrcode_change, version_qrcode_sort, version_qrcode_del } from "@/api/index";
export default {
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 30,
                keywords: "",
                status: -1,
            },
            total: 0,
            statusList: [
                { id: -1, name: "全部" },
                { id: 0, name: "下架" },
                { id: 1, name: "上架" },
            ],
            columnsTable: [
                { type: "index", width: 60, align: "center" },
                { title: "序号", key: "sort", align: "center" },
                { title: "溯源码套餐名称", key: "name", align: "center" },
                { title: "码数量", key: "nums", align: "center" },
                { title: "状态", slot: "status", align: "center" },
                { title: "创建时间", key: "created_at", align: "center" },
                { title: "金额", key: "price", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "200px" },
            ],
            dataTable: [],
            modals: false,
            modalTitle: "",
            form_item: {
                name: "",
                sort: "",
                nums: "",
                price: "",
                ori_price: "",
                id: "",
            },
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList() {
            version_qrcode(this.storePrams).then((res) => {
                this.dataTable = res.data.data;
                this.total = res.data.total;
            });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        goSearch() {
            this.storePrams.page = 1;
            this.getList();
        },
        getQrcodeSort(){
            version_qrcode_sort().then((res) => {
                this.form_item.sort = res.data.sort;
            });
        },
        gomodal(row) {
            if (row.id) {
                this.modalTitle = "编辑码套餐";
                this.form_item.name = row.name;
                this.form_item.sort = row.sort;
                this.form_item.nums = row.nums;
                this.form_item.price = row.price;
                this.form_item.ori_price = row.ori_price;
                this.form_item.id = row.id;
            } else {
                this.modalTitle = "增加码套餐";
                this.form_item.name = "";
                this.form_item.nums = "";
                this.form_item.price = "";
                this.form_item.ori_price = "";
                this.form_item.id = "";
                this.getQrcodeSort();
            }
            this.modals = true;
        },
        // 确定
        submitModal() {
            version_qrcode_save(this.form_item)
                .then((res) => {
                    this.getList();
                    this.modals = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        cancelModal() {
            this.modals = false;
        },
        changeStatus(row) {
            this.$Modal.confirm({
                title: "提示",
                content: "确认改变状态吗？",
                onOk: () => {
                    version_qrcode_change({ id: row.id })
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {
                    this.getList();
                },
            });
        },
        goDel(row) {
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？",
                onOk: () => {
                    version_qrcode_del({ id: row.id })
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {},
            });
        },
    },
};
</script>

<style scoped>
.content {
    padding: 24px;
    background: #FFFFFF;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.header {
    padding: 24px 24px 0 24px;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    background-color: #FFFFFF;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.text-align-right {
    text-align: right;
}
.tooltip-icon {
    margin-left: 10px;
    cursor: pointer;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-checkbox-group.ivu-checkbox-default {
    display: inline-block;
}
</style>